import { MangoTurnBack } from '@intellihr/blueberry'
import React from 'react'
import { useScope } from 'src/services/i18n/LocalizationProvider'
import { urlForLapisRoute } from 'src/services/routes'
import { useErrorFooterButtons } from 'src/services/error/components/ErrorFooter'
import { StyledTurnBackWrapper } from '../style'

const AssumedUserAccountsDenied: React.FC = () => {
  const tCommon = useScope('common:error.AssumedUserAccountsDenied')
  const errorFooterButtons = useErrorFooterButtons()

  return (
    <StyledTurnBackWrapper>
      <MangoTurnBack
        variant="identity-error"
        title={tCommon('headerPrimary', { defaultValue: 'Feature Unavailable' })}
        description={[
          tCommon('headerSecondary', {
            defaultValue: "This feature isn't available while assuming another person's user account.",
          }),
          <tCommon.Trans
            key="instruction-list"
            i18nKey="instructions"
          >
            <span>To access the feature, </span>
            <a href={urlForLapisRoute('acls.exit_assumed_role')}>exit your assumed permission group</a>
          </tCommon.Trans>,
        ]}
        actions={errorFooterButtons}
      />
    </StyledTurnBackWrapper>
  )
}

const MemoAssumedUserAccountsDenied = React.memo(AssumedUserAccountsDenied)

export { MemoAssumedUserAccountsDenied as AssumedUserAccountsDenied }
